import { Component, OnDestroy } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { SiteDepartmentCard, SiteDepartmentService } from '../../site-department.service';
import { SiteDoctor, SiteDoctorService } from '../../site-doctor.service';
import { SiteNavService } from '../../site-nav.service';
import { DEPARTMENT_SLUG_PREFIX } from '../../site-utils';

@Component({
  selector: 'ws-site-department',
  templateUrl: './department.component.html'
})
export class SiteDepartmentPageComponent implements OnDestroy {
  department: SiteDepartmentCard | undefined;
  doctors: SiteDoctor[] = [];
  name = '';

  private readonly sub: Subscription;

  constructor(nav: SiteNavService, departments: SiteDepartmentService, doctorService: SiteDoctorService) {
    this.sub = combineLatest(nav.page$, departments.cards$, doctorService.doctors$).subscribe(([page]) => {
      const id = page.slug.indexOf(DEPARTMENT_SLUG_PREFIX) === 0 ? page.slug.substring(DEPARTMENT_SLUG_PREFIX.length) : '';
      this.department = departments.findBySlug(page.slug);
      this.doctors = doctorService.forDepartmentId(id);
      this.name = this.department ? this.department.name : (this.doctors[0] ? this.doctors[0].departmentName : '');
    });
  }

  ngOnDestroy() { this.sub.unsubscribe(); }
}
